export default "__VITE_ASSET__DM8jpRzq__"